<template>
  <!-- 收藏 -->
  <div v-if="total>0" v-loading="fullscreenLoading">
    <div class="cont-shoucang clearfix">
      <div class="work-card-one" v-for="(item, index) in tableData" :key="index">
        <router-link v-if="item.objectType==1" :title="item.objectName" :to="{path:'/worksdetail',query:{id:item.production.id,plate:item.production.belongSection}}"  target="_blank" class="img-f">
          <img :src="item.img" alt="">
        </router-link>
        <router-link v-if="item.objectType==2"  :title="item.objectName" :to="{path:'/column/themedetail',query:{id:item.archive.id,plate:item.archive.belongSection}}"  target="_blank" class="img-f">
          <img :src="item.img" alt="">
        </router-link>
        <router-link v-if="item.objectType==6 && item.model.materialSort == 1" :title="item.objectName" :to="{path:'/modeldetail',query:{id:item.model.id,plate:item.model.belongSection}}"  target="_blank" class="img-f">
          <img :src="item.img" alt="">
        </router-link>

        <!-- <router-link v-else-if="item.objectType==6 && item.model.materialSort == 2" :title="item.objectName" :to="{path:'/audio/detail',query:{id:item.model.id}}"  target="_blank" class="img-f audio-img-show">
          <img :src="require('@/assets/images/audio_img.jpg')" alt="">
        </router-link> -->
        <router-link v-else-if="item.objectType==6 && item.model.materialSort == 2" :title="item.objectName" :to="{path:'/audio/detail',query:{id:item.model.id,plate:item.model.belongSection}}"  target="_blank" class="img-f" :style="{'background-image': 'url('+require('@/assets/images/audio_img.jpg')+')'}" style="background-size: cover;background-position: center center">
        </router-link>
        
        <router-link v-if="item.objectType==6 && item.model.materialSort == 3" :title="item.objectName" :to="{path:'/action/detail',query:{id:item.model.id,plate:item.model.belongSection}}"  target="_blank" class="img-f">
          <img :src="item.img" alt="">
        </router-link>

        <router-link v-if="item.objectType==12"  :title="item.objectName" :to="{path:'/filmdetail',query:{id:item.section.id}}"  target="_blank" class="img-f">
          <img :src="item.img" alt="">
        </router-link>

        <div class="card-infoes">
          <router-link v-if="item.objectType==1" :to="{path:'/worksdetail',query:{id:item.production.id,plate:item.production.belongSection}}"  target="_blank" class="card-tit over-ellipsis" :title="item.objectName">{{item.objectName}}</router-link>
          <router-link v-if="item.objectType==2" :to="{path:'/column/themedetail',query:{id:item.archive.id,plate:item.archive.belongSection}}"  target="_blank" class="card-tit over-ellipsis" :title="item.objectName">{{item.objectName}}</router-link>
          <router-link v-if="item.objectType==6 && item.model.materialSort == 1" :to="{path:'/modeldetail',query:{id:item.model.id,plate:item.model.belongSection}}"  target="_blank" class="card-tit over-ellipsis" :title="item.objectName">{{item.objectName}}</router-link>
          <router-link v-else-if="item.objectType==6 && item.model.materialSort == 2" :to="{path:'/audio/detail',query:{id:item.model.id,plate:item.model.belongSection}}"  target="_blank" class="card-tit over-ellipsis" :title="item.objectName">{{item.objectName}}</router-link>
          <router-link v-else-if="item.objectType==6 && item.model.materialSort == 3" :to="{path:'/action/detail',query:{id:item.model.id,plate:item.model.belongSection}}"  target="_blank" class="card-tit over-ellipsis" :title="item.objectName">{{item.objectName}}</router-link>
          <router-link v-if="item.objectType==12" :to="{path:'/filmdetail',query:{id:item.section.id}}"  target="_blank" class="card-tit over-ellipsis" :title="item.objectName">{{item.objectName}}</router-link>

          <div v-if="item.objectType == 1" class="card-tags over-ellipsis">{{item.production.tagStr}}</div>
          <div v-if="item.objectType == 2" class="card-tags over-ellipsis">{{item.archive.auditStatusStr == ''
            ?"暂无": item.archive.auditStatusStr}}
          </div>
          <div v-if="item.objectType == 6" class="card-tags over-ellipsis">{{item.model.modelTags == ''
            ?"暂无": item.model.modelTags}}
          </div>
          <div v-if="item.objectType == 12" class="card-tags over-ellipsis"></div>


          <div class="card-czs" v-if="item.objectType == 1">
            <i class="icon zan"></i><span class="much">{{item.production.likeCount}}</span>
            <i class="icon cai"></i><span class="much">{{item.production.dislikeCount}}</span>
            <i class="icon pinglun"></i><span class="much">{{item.production.commentCount}}</span>
            <i class="icon zhuanfa"></i><span class="much">{{item.production.shareCount}}</span>
          </div>
          <div class="card-czs" v-if="item.objectType == 2">
            <i class="icon zan"></i><span class="much">{{item.archive.likeCount}}</span>
            <i class="icon cai"></i><span class="much">{{item.archive.dislikeCount}}</span>
            <i class="icon pinglun"></i><span class="much">{{item.archive.commentCount}}</span>
            <i class="icon zhuanfa"></i><span class="much">{{item.archive.shareCount}}</span>
          </div>
          <div class="card-czs" v-if="item.objectType == 6">
            <i class="icon zan"></i><span class="much">{{item.model.likeCount}}</span>
            <i class="icon cai"></i><span class="much">{{item.model.dislikeCount}}</span>
            <i class="icon pinglun"></i><span class="much">{{item.model.commentCount}}</span>
            <i class="icon zhuanfa"></i><span class="much">{{item.model.shareCount}}</span>
          </div>
          <div class="card-czs" v-if="item.objectType == 12">
            <i class="icon zan"></i><span class="much">{{item.section.likeCount}}</span>
            <i class="icon cai"></i><span class="much">{{item.section.dislikeCount}}</span>
            <i class="icon pinglun"></i><span class="much">{{item.section.commentCount}}</span>
            <i class="icon zhuanfa"></i><span class="much">{{item.section.shareCount}}</span>
          </div>


        </div>
        <div class="auther" v-if="item.objectType == 1">
          <router-link target="_blank" :to="{path:'/home', query: {userId:item.production.creatorId}}" class="avatar-f">
            <img :src="`http://iss.21teacher.com/avatar/125/${item.production.creatorId}/20.jpg`" alt="">
          </router-link>
          <router-link target="_blank"
                       :to="{path:'/home', query: {userId:item.production.creatorId}}"
                       class="user-name over-ellipsis">{{item.production.creatorName}}
          </router-link>
          <div class="date">{{item.collectTime | formatTime}}</div>
        </div>
        <div class="auther" v-if="item.objectType == 2">
          <router-link target="_blank" :to="{path:'/home', query: {userId:item.archive.creatorId}}" class="avatar-f">
            <img :src="`http://iss.21teacher.com/avatar/125/${item.archive.creatorId}/20.jpg`" alt="">
          </router-link>

          <router-link target="_blank"
                       :to="{path:'/home', query: {userId:item.archive.creatorId}}"
                       class="user-name over-ellipsis">{{item.archive.creatorName}}
          </router-link>
          <div class="date">{{item.collectTime | formatTime}}</div>
        </div>
        <div class="auther" v-if="item.objectType == 6">
          <router-link target="_blank" :to="{path:'/home', query: {userId:item.model.creatorId}}" class="avatar-f">
            <img :src="`http://iss.21teacher.com/avatar/125/${item.model.creatorId}/20.jpg`" alt="">
          </router-link>

          <router-link target="_blank"
                       :to="{path:'/home', query: {userId:item.model.creatorId}}"
                       class="user-name over-ellipsis">{{item.model.creatorName}}
          </router-link>
          <div class="date">{{item.collectTime | formatTime}}</div>
        </div>

        <div class="auther" v-if="item.objectType == 12">
          <router-link target="_blank" :to="{path:'/home', query: {userId:item.section.creatorId}}" class="avatar-f">
            <img :src="`http://iss.21teacher.com/avatar/125/${item.section.creatorId}/20.jpg`" alt="">
          </router-link>

          <router-link target="_blank"
                       :to="{path:'/home', query: {userId:item.section.creatorId}}"
                       class="user-name over-ellipsis">{{item.section.creatorName}}
          </router-link>
          <div class="date">{{item.collectTime | formatTime}}</div>
        </div>
      </div>
      <!-- 放映厅影片收藏 -->
      <!-- <div class="work-card-one">
        <router-link to="" class="img-f" title="MP4音效" target="_blank">
          <img src="http://ocs.21teacher.com/dir-image/2020/4/16/705aba12c91d4f2c993d8876e217e2a5.jpg" alt="">
          <span class="film-rate">9.6</span>
        </router-link>
        <div class="card-infoes">
          <router-link to="" class="card-tit over-ellipsis" target="_blank" title="中华上下五千年 第5集">中华上下五千年 第5集</router-link>
          <div class="card-tags over-ellipsis">历史 / 原创 / 国漫</div>
          <div class="card-czs">
            <i class="icon zan"></i>
            <span class="much">0</span>
            <i class="icon cai"></i>
            <span class="much">0</span>
            <i class="icon pinglun"></i>
            <span class="much">8</span>
            <i class="icon zhuanfa"></i>
            <span class="much">0</span>
          </div>
        </div>
        <div class="auther">
          <router-link to="" class="avatar-f router-link-active" target="_blank">
            <img src="http://iss.21teacher.com/avatar/125/1/20.jpg" alt="">
          </router-link>
          <router-link to="" class="user-name over-ellipsis router-link-active" target="_blank">管理员</router-link>
          <div class="date">2 个月前</div>
        </div>
      </div> -->
    </div>
    <div class="pagintion-f">
      <el-pagination
              background
              @current-change="collectPageList"
              layout="prev, pager, next"
              :current-page=queryParam.pageIndex
              :page-size="queryParam.pageSize"
              :hide-on-single-page="true"
              :total="total">
      </el-pagination>
    </div>
  </div>
  <div v-else class="common-no-data">
    <img class="img" :src="require('@/assets/images/empty_img.png')" alt="">
    <span class="words">抱歉！您访问的页面暂无数据</span>
  </div>
</template>


<script type="text/ecmascript-6">
  import homeApi from '@/api/home'
  import {mapState} from "vuex";
  import updateTdk from "@/utils/tdk";

  export default {
    components: {},
    data() {
        return {
          headTitle: "title---rrdh",
          headKeywords: "keywords---rrdh",
          headDesc: "description---rrdh",
          isMounted: false, //for control not ssr render

          tableData: [],
            total: 0,
            fullscreenLoading: true,
            queryParam: {
                userId: 0,
                currentUserId: 0,
                pageIndex: 1,
                pageSize: 10
            },
        }
    },
  computed: {
    ...mapState(["userDetail"])
  },
  tdk() {
    return {
      title: this.headTitle,
      description: this.headDesc,
      keywords: this.headKeywords,
      ssrHeadAddInfo: `<link rel="canonical" href="http://www.renrendonghua.com">`
    };
  },
  serverPrefetch() {
    return this.fetchData();
  },
  destroyed() {
    this.$store.commit("SET_USER_DETAIL", { detail: null });
  },
    mounted() {

      this.isMounted = true;

      let id = this.$route.query.userId
      if (id && parseInt(id) !== 0) {
        this.queryParam.userId = id
      }
      if (this.global.userModel != null) {
        this.queryParam.currentUserId = this.global.userModel.id
      }

      const alreadyIncremented = !!this.productionDetail;
      if (!alreadyIncremented) {
        this.fetchData().then(this.initData());
      } else {
        this.initData();
      }

    },
    methods: {
      fetchData(){
        return this.$store
                .dispatch("FETCH_USER_DETAIL", {
                  id: this.$route.query.userId
                })
                .finally(() => {
                  this.$loading(false);
                  console.log("this.userDetail =====  ",this.userDetail)
                  this.setSeo()
                  updateTdk.call(this);
                });
      },
      initData(){
        this.collectPageList(1)
      },
      setSeo(){
        this.headTitle = this.userDetail.userName+"的收藏——人人动画网【官网】";
        this.headKeywords = this.userDetail.impressStr;
        this.headDesc =this.userDetail.userName+"的收藏";
      },
      collectPageList(page) {
          this.queryParam.pageIndex = page
          this.fullscreenLoading = true
          homeApi.collectPageList(this.queryParam).then(data => {
              console.log(data)
              const re = data
              this.tableData = re.list
              this.total = re.total
              this.fullscreenLoading = false
          })
      },

    }
}
</script>

<style scoped lang="less">
.pagintion-f {
  padding: 20px 0 40px;
  text-align: center;
}

//@import "../../../assets/less/stylePublic.less";
</style>
